// extracted by mini-css-extract-plugin
module.exports = {"root":"Body_root__jJ8p7","titleWrapper":"Body_titleWrapper__1C6zo","title":"Body_title__ZmP4z","empty":"Body_empty__3H7p_"};